module.exports = __webpack_public_path__ + "static/media/notification-read.dd76b357.svg";